import { ReactNode } from 'react';
import emotionReset from 'emotion-reset';
import { Global, css } from '@emotion/react';
interface ProviderProps {
  children: ReactNode;
}

const Provider = ({ children }: ProviderProps) => {
  return (
    <>
      <Global
        styles={css`
          ${emotionReset}
          #root {
            min-width: 880px;
          }
        `}
      />
      {children}
    </>
  );
};

export default Provider;
